export default {
  title: 'Dołącz do {{name}}!',
  default_program_name: 'Klub nagród',
  savings_highlight: {
    title: 'Zdobywaj nagrody. Za każde zamówienie.',
    subtitle: 'Zarejestruj się w kilka sekund i zacznij zdobywać punkty.',
  },
  how_it_works: {
    label: 'Jak to działa',
    step_1: {
      title: 'Rejestracja w 30 sek.',
      desc: 'Tylko numer telefonu',
    },
    step_2: {
      title: 'Zamów i zbieraj',
      desc: '{{percentage}}% zwrotu za każde zamówienie',
    },
    step_3: {
      title: 'Zrealizuj i oszczędzaj',
      desc: 'Do {{amount}} zniżki na zamówienie',
    },
  },
  profile: {
    verified_title: 'Telefon zweryfikowany!',
    verified_subtitle: 'Uzupełnij profil, aby zacząć zdobywać punkty.',
  },
  form: {
    phone_number: {
      label: 'Numer telefonu',
      description: 'Wyślemy kod weryfikacyjny, aby potwierdzić Twoją tożsamość.',
      placeholder: 'Numer telefonu',
    },
    birthday: {
      label: 'Urodziny — wystarczy dzień i miesiąc, by dostać prezent 🥳',
      placeholder: 'Urodziny (opcjonalne)',
      parts: {
        month: 'Miesiąc',
        day: 'Dzień',
      },
    },
  },
  terms:
    'Rejestrując się, akceptujesz nasz <TermsLink>regulamin</TermsLink> i wyrażasz zgodę na naszą <PrivacyPolicyLink>politykę prywatności</PrivacyPolicyLink>.',
  buttons: {
    continue: 'Dalej',
    verify: 'Zweryfikuj',
    complete: 'Zakończ rejestrację',
  },
  toasts: {
    login_success: 'Zalogowano pomyślnie',
    invalid_code: 'Nieprawidłowy kod. Spróbuj ponownie.',
    failed_to_update_profile: 'Nie udało się zaktualizować profilu. Spróbuj ponownie.',
  },
};
